import React from 'react'
import { Box } from 'reflexbox'

export default ({ variant, children, ...props }) => (
  <Box as="span" tx="text" lineHeight={1.3} {...props}>
    {children}
  </Box>
)
